<template>
  <nuttrema-menu-list>
    <nuttrema-loader-pulsating v-if=" InstanceSubscribedPlanSummarized.fetching"></nuttrema-loader-pulsating>
    <template
      v-else
      v-for="navigation in navigations">

      <template v-if="checkPageRequiredSubscribedFeature(navigation, SubscribedPlan)">
        <nuttrema-menu-list-item
           v-if="navigation.pages && navigation.pages.length > 0"
          :class="{ 'is-active': $route.path.startsWith(navigation.url) }"
          theme="sidebar-menu">
          <el-popover
            placement="right"
            trigger="hover"
            width="240">
            <nuttrema-menu-list theme="popover-nav">
              <nuttrema-menu-list-item>
                <p class="list-item-label">{{ $t(navigation.label) }}</p>
              </nuttrema-menu-list-item>
              <section>
                <nuttrema-menu-list-item v-for="(page, childIndex) in navigation.pages" :key="page.url">

                  <template v-if="checkPageRequiredSubscribedFeature(page, SubscribedPlan)">
                    <router-link
                       tag="a"
                       class="list-item-link"
                       activeClass="is-active"
                      :exact="false"
                      :to="{ name: page.name }">
                      <span>{{ $t(page.label) }}</span>
                    </router-link>
                  </template>

                  <!-- <template v-else>
                    <a class="list-item-link is-lock">
                      <span>{{ $t(page.label) }} <i class="far fa-lock-alt"></i></span>
                    </a>
                  </template> -->

                </nuttrema-menu-list-item>
              </section>
            </nuttrema-menu-list>
            <nuttrema-iconica-sidebar-link
               slot="reference"
              :icon="navigation.navigationIcon"
              :text="$t(navigation.label)"
              @mouseenter="$emit('mouseenter')"
              @click="$emit('click')">
            </nuttrema-iconica-sidebar-link>
          </el-popover>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item v-else>
          <router-link
             tag="a"
             activeClass="is-active"
             exact
            :to="{ name: navigation.name }">
            <nuttrema-iconica-sidebar-link
              :icon="navigation.navigationIcon"
              :text="$t(navigation.label)">
            </nuttrema-iconica-sidebar-link>
          </router-link>
        </nuttrema-menu-list-item>
      </template>
      <!-- end ~ checkPageRequiredSubscribedFeature -->

    </template>
  </nuttrema-menu-list>
</template>

<script>
import { flow, sortBy, last, get } from 'lodash';
import { checkPageRequiredSubscribedFeature } from 'utils/check-permissions';
// import { NavigationsAuthorized } from 'data';

import SidebarMenu from 'components/ui/menu/sidebar-menu';
import NuttremaLoaderPulsating from 'components/ui/panels/nuttrema-loader-pulsating';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sidebar-menu-level-zero-collapsed',
  mixins: [
    SidebarMenu,
  ],
  components: {
    NuttremaLoaderPulsating,
    NuttremaIconicaSidebarLink,
  },
  computed: {
    InstanceSubscribedPlanSummarized() {
      return this.$store.getters.InstanceSubscribedPlanSummarized;
    },
    SubscribedPlan() {
      return get(this.InstanceSubscribedPlanSummarized, 'data.subscribed_plan');
    },
  },
  methods: {
    handleOpen() {},
    handleClose() {},
    getActiveLink() {
      const link = flow(sortBy(n => n.path.length), last)(this.$route.matched);
      this.activeLink = link.path !== '' ? link.path : '/';
      const count = (link.path.match(new RegExp('/', 'g')) || []).length;
      if (count > 2) {
        const parts = link.path.split('/');
        this.activeLink = `/${parts[1]}`;
      }
    },
    checkPageRequiredSubscribedFeature,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed.vue